import React from "react";
import { useNavigate } from 'react-router-dom';
import "./Footer.css";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="newhome-footer">
      <div className="newhome-footer-bottom">
        <small>Copyright © {new Date().getFullYear()} CHdropshipping. All rights reserved.</small>
        <div style={{ marginTop: '0.5rem', textAlign: 'center', fontSize: 'smaller' }}>
          <a onClick={() => navigate('/about-us')} style={{ cursor: 'pointer', color: '#666', textDecoration: 'underline', marginRight: '1rem' }}>About us</a>
          <a href="/privacy_policy.html" style={{ color: '#666', textDecoration: 'underline' }}>Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
